import { effect, Injectable, signal } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/Auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class EnabledGuard implements CanActivate {

    timeout: any
    isEnabled  : boolean = false
    

    constructor(
        private authService: AuthService,
        private router: Router
    ) { 
        effect(() => {
            this.isEnabled = this.authService.isEnabledSig()
        })
    }


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return new Promise((resolve) => {

            // effect(() => {
            // var x = this.authService.isEnabledSig()
            //     if (this.authService.isEnabledSig()) {
            //         this.router.navigate(['/login']);
            //         resolve(true)
            //     }
            //     else {
            //         resolve(false)

            //         this.timeout = setTimeout(() => {
            //             this.router.navigate(['/login']);
            //         }, 6000);
            //     }
            // })

            this.authService.isEnabled$.subscribe(res => {
                clearTimeout(this.timeout);
                if (res != null) {
                    // if (!res) {
                    var debugVal = this.authService.isEnabledSig()
                    if(!this.authService.isEnabledSig() && !this.router.url.includes('/login')) {
                        this.authService.setPathAfterLogin(window.location.pathname)
                        this.router.navigate(['/login']);
                    }
                    resolve(this.authService.isEnabledSig())
                }
                else {
                    this.timeout = setTimeout(() => {
                        this.authService.setPathAfterLogin(window.location.pathname)
                        this.router.navigate(['/login']);
                    }, 6000);
                }
            })

        })
    }

}


// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };
